<template>
    <div id="WarrantyLimitation" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">

                    <div class="page-name">Warranty Limitation

                        <!-- <router-link v-bind:to="'/warranty/list'" class="btn btn-secondary pull-right" >
                          <i class="fp-back"></i>  Back
                        </router-link> -->
                        <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackWarrantyList" >
                            <i class="fp-back"> </i>    Back
                        </button>

                    </div>

                    <div class="container-fluid">
                    <div class="admin-page-content">
                        <!-- <div class="admin-page-content"> -->
                            <section class="internal-container border-top-table-fl">
                                <!-- <div class="container"> -->
                                    <div class="form-row section-divider">
                                        <div class="col-md-4">
                                            <div class="row form-group">
                                                <label class="col">Warranty:</label>
                                                <span class="col"> {{ucString(warCode)}} </span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="row form-group">
                                                <label class="col">Starting Point Value:</label>
                                                <span class="col"> {{ucString(starting_point_value)}} </span>
                                            </div>
                                        </div>
                                    </div>
                                    <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="WarrantyForm">
                                        <!-- <div class="form-row row-cols-md-6 row-cols-1">
                                            <h5 class="col section-title"> Component </h5>
                                        </div> -->
                                        <div class="form-row row-cols-md-3 row-cols-1">
                                            <div class="col form-group">
                                                <label class="control-label require" for="component">VMRS:</label>
                                                <v-select v-model="itemCategory" name="itemCategory" label="text" :filterable="false" :options="vmrsArr" @search="onSearchComponent" placeholder="Search Component" class="custom-ci-auto-search">
                                                    <template slot="no-options">
                                                        Search Component...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                                <div class="field-error">{{ itemCatError }}</div>
                                            </div>
                                            <div class="col form-group">
                                                <label class="control-label require" for="include-exclude">Warranty Include/Exclude:</label>
                                                <v-select v-model="is_applied" name="is_applied" placeholder="Select Warranty Include/Exclude"
                                                    label="text" class="close-remove"
                                                    :options="isAppliedArr">
                                                </v-select>
                                                <div class="field-error">{{is_appliederror}}</div>
                                            </div>
                                            <div class="col form-group mt-4">
                                                <div class="btn-groups">
                                                    <button v-if="!updateFlag" type="submit" v-on:click.prevent="AddWarrantyLimitation('add')" class="btn btn-primary pull-left">
                                                        <i class="fp-add"></i> Add
                                                    </button>
                                                    <button v-if="updateFlag" type="submit" v-on:click.prevent="AddWarrantyLimitation('update')" class="btn btn-primary pull-left">
                                                        <i class="fp-reload"></i> Update
                                                    </button>
                                                    <button type="submit" v-on:click.prevent="cancelWarrantyLimitation()" class="btn btn-tertiary pull-left ml-2">
                                                        <i class="fp-refresh"></i> Reset
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                <strong id="errorMsg" class="error"></strong>
                                            </div>
                                        </div>

                                    </form>
                                    <div class="form-row mb-2" style="overflow:hidden;">
                                        <div class="col-md-6">
                                        </div>
                                        <div class="col-md-6 btn-groups text-right">
                                            <button v-if="idArr.length > 0" type="submit" id="removeLimit" v-on:click.prevent="removeLimitation()" class="btn btn-primary pull-right">
                                                <i class="fp-remove"> </i>  Remove
                                            </button>
                                        </div>
                                    </div>
                                    <div class="purchase-order-create-main table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th scope="col" style="width:40px;"></th>
                                                    <th scope="col">VMRS</th>
                                                    <th scope="col">Warranty Included/Excluded</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="rows != undefined && rows.length > 0">
                                                    <tr v-for="(asset, index2) in rows" v-bind:key="index2">
                                                        <td style="width:40px;">
                                                            <input type="checkbox" @input="saveId($event,asset.id)" :id="'checkComp'+index2"/>
                                                        </td>
                                                        <td>{{ asset.item }}</td>
                                                        <td>{{ asset.is_applied }}</td>
                                                        <td>
                                                            <a title="Edit Warranty" href="javascript:void(0)" class="fp-edit" v-on:click="getWarrantyLimitation(asset.id)"></a>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-else>
                                                    <tr>
                                                        <td colspan="4" style="text-align:center;">
                                                            No Limitation Available.
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>

                                <!-- </div> -->
                            </section>
                        <!-- </div>        -->
                    </div>
                    </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
    export default {
        name: "WarrantyLimitation",
        metaInfo() {
            return {title: "Warranty Limitation | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,contractMixins],

        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: true,
            error:"",
            notfound:false,
            notFoundArr:[],
            unitNum:"",
            id:0,
            customer_value: false,
            loading:false,
            fromDate:"",
            readingError:"",
            unit:"",
            readingDate:"",
            showSelectAllLink:false,
            buttonVis:false,
            warCode:"",
            warrantyId:"",
            currentStatus:"Yes",
            starting_point_value:"",
            effective_date:"",
            expiry_date:"",
            isAppliedArr:[{text:'Included',value:1},{text:'Excluded',value:0}],
            is_appliederror:'',
            description:'',
            itemCategory:'',
            itemCatError:'',
            AddwarrantyFlag:false,
            updateWarrantyFlag:false,
            componentCategoryArr:[],
            is_applied:'',
            descriptionerrors:'',
            warranty_id:0,
            rows:[],
            limitData:[],
            updateFlag:false,
            limitationId:0,
            idArr:[],
            period:'',
            vmrsArr: [],
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_warranty') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {
        },
        mounted: function() {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.warrantyId = segments[2];
            self.getPermissions();
            // this.loadReport();
            self.getWarrantyInfo(segments[2]);
            self.loadLimitationList();

        },
        methods: {
            BackWarrantyList() {
                var self = this;
                if (self.$route.query.wo != undefined){
                    self.$router.push("/warranty/view/"+self.$route.query.wo);
                }else{
                    self.$router.push("/warranty/list");
                }
            },
            getWarrantyInfo(id){
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/warranty/"+id,
                    type: "GET",
                    headers: this.ajxHeaders,
                    data:{flag:'from_asset'},
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);
                        self.warCode = data.content.description+' ('+data.content.code+')  /'+data.content.period+' '+data.content.period_type;
                        self.starting_point_value = data.content.starting_point_value;
                        self.effective_date = data.content.effective_date;
                        self.expiry_date = data.content.expiry_date;

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },

            getWarrantyLimitation(id){
                var self = this;
                self.loading = true;
                self.itemCatError = "";
                self.is_appliederror = "";
                self.idArr = [];
                self.refreshComponents();

                $.ajax({
                    url: process.env.ROOT_API + "/warranty-limitation/"+id,
                    type: "GET",
                    headers: this.ajxHeaders,

                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);
                        self.itemCategory = {text:data.content.itemCatCode+' | '+data.content.itemCatName,value:data.content.itemCatId};
                        self.is_applied = {text:data.content.appliedText,value:data.content.appliedValue};
                        self.updateFlag = true;
                        self.limitationId = data.content.id;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            onSearchComponent(search, loading) {
                var self = this;
                if (search.length > 2) {

                    loading(true);
                    self.searchField(loading, search, 'vmrs', '');
                }
            },

            loadLimitationList() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                self.loading = true;
                // self.rows = [];
                var fields = {
                    warranty_id:segments[2],
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/warranty-limitations/list",
                    type: "GET",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);
                        if (data.code == 200) {
                            self.rows = data.content.row;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            AddWarrantyLimitation(flag) {

                var self = this;
                var error = false;

                var path = window.location.pathname;
                var segments = path.split("/");

                self.descriptionerrors = "";
                self.is_appliederror = "";
                self.itemCatError = '';

                var limitationId = 0;
                if ( flag == 'update' ){

                    limitationId = self.limitationId;
                }

                // if (!self.description || description.reading == '') {
                //     self.descriptionerrors = 'Description Required';
                //     error = true;
                // }

                if(self.itemCategory == null){
                    self.itemCategory = '';
                }
                if(self.itemCategory == '' || !self.itemCategory.value ){
                    self.itemCatError = 'Component Required';
                    error = true;
                }

                if ( self.is_applied == null ) {
                    self.is_applied = '';
                }

                if ( self.is_applied == '' ) {
                    self.is_appliederror = "Included or Exluded Required";
                    error = true;
                }

                if (self.rows && self.rows.length){
                    for(var i = 0; i < self.rows.length; i++){
                        if (self.is_applied.text && self.rows[i].is_applied != self.is_applied.text && self.itemCategory.text && self.rows[i].item != self.itemCategory.text){
                            self.is_appliederror = 'Either Include or Exclude can be selected for one warranty';
                            return;
                        }
                    }
                }

                var fields = {
                    id:self.warranty_id,
                    limitationId:limitationId,
                    itemCategory:self.itemCategory.value,
                    is_applied:self.is_applied.value,
                    description:self.description,
                    warranty:segments[2],
                }
                // if (result) {
                if (!error) {
                    self.loading = true;


                    if (self.warranty_id > 0)
                    {
                        $("#createWarrantyBtn").val("Updating ...");
                        $("#createWarrantyBtn").prop("disabled", true);
                        $("#cancelWarrantyBtn").prop("disabled",true);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueWarrantyBtn").val("Saving ...");
                            $("#createWarrantyBtn").prop("disabled", true);
                            $("#createAndContinueWarrantyBtn").prop("disabled", true);
                            $("#cancelWarrantyBtn").prop("disabled",true);

                        }else{

                            $("#createWarrantyBtn").val("Saving ...");
                            $("#createWarrantyBtn").prop("disabled", true);
                            $("#createAndContinueWarrantyBtn").prop("disabled", true);
                            $("#cancelWarrantyBtn").prop("disabled",true);
                        }

                    }

                    $.ajax({
                        url: process.env.ROOT_API + "/warranty-limitation/add",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.code == 200) {

                                self.itemCategory = null;
                                self.is_applied = {text:'Included',value:1};
                                self.loadLimitationList();
                                self.updateFlag = false;
                                self.idArr = [];

                            }

                            if (flag == "Save and Continue") {

                                $("#createAndContinueWarrantyBtn").val("Save and Continue");
                                $("#createWarrantyBtn").prop("disabled", false);
                                $("#createAndContinueWarrantyBtn").prop("disabled", false);
                                $("#cancelWarrantyBtn").prop("disabled",false);

                            } else {

                                $("#createWarrantyBtn").val("Save");
                                $("#createWarrantyBtn").prop("disabled", false);
                                $("#createAndContinueWarrantyBtn").prop("disabled", false);
                                $("#cancelWarrantyBtn").prop("disabled",false);

                            }

                            if ( data.code == 201){

                                self.$swal('',data.message,'info');
                            }

                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (segments[3])
                            {
                                $("#createWarrantyBtn").val("Update");
                                $("#createWarrantyBtn").prop("disabled", false);
                                $("#cancelWarrantyBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#createAndContinueWarrantyBtn").val("Save and Continue");
                                    $("#createWarrantyBtn").prop("disabled", false);
                                    $("#createAndContinueWarrantyBtn").prop("disabled", false);
                                    $("#cancelWarrantyBtn").prop("disabled",false);

                                }else{

                                    $("#createWarrantyBtn").val("Save");
                                    $("#createWarrantyBtn").prop("disabled", false);
                                    $("#createAndContinueWarrantyBtn").prop("disabled", false);
                                    $("#cancelWarrantyBtn").prop("disabled",false);

                                }
                            }
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    self.$router.push("/");
                                }
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    });
                }
            },
            saveId(evt,id){
                var self = this;
                // alert(id);
                console.log(evt.target.checked);
                if(evt.target.checked == true){
                    self.idArr.push({id:id});
                }else{
                    var i = self.idArr.indexOf(id);
                    const filteredItems = self.idArr.filter(function(item) {
                        return item.id !== id
                    })
                    self.idArr = filteredItems;
                }
                console.log(self.idArr);
            },

            removeLimitation:  function(){
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/limitation/remove",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data:{
                        ids:self.idArr
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);
                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                        }else{
                            self.$swal('',data.message,'success');
                        }
                        if (data.status == "success") {

                            self.loadLimitationList();
                            self.idArr = [];
                            self.refreshComponents();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            cancelWarrantyLimitation() {
                var self = this;
                self.itemCatError = "";
                self.is_appliederror = "";
                self.itemCategory = "";
                self.is_applied = "";
                self.updateFlag = false;
                self.idArr = [];
                self.refreshComponents();
            },
            refreshComponents() {
                var self = this;
                for (var i = 0;i < self.rows.length;i++) {
                    $("#checkComp" + i). prop("checked", false); //check selected insurance policy
                }
            },
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/WarrantyLimitation.vue